import { Tooltip } from 'antd'
import React from 'react'

export const Web3Address = ({ address }: {address: string}): JSX.Element => {
  return (
    <Tooltip title={address}>
        <span>{address.slice(0, 5) + '...' + address.slice(address.length - 4)}</span>
    </Tooltip>
  )
}
